module.exports = __webpack_public_path__ + "media/empty-states/tickets-2x-087a9bbc.png";